import { useGrid } from 'utils/hooks/useGrid';

export const useSettings = () => {
  const { setGridSettingsAndStore } = useGrid();
  const setGridSettings = (settings: any) => setGridSettingsAndStore(settings);

  return { setGridSettings };
};
